import { apiGateway } from '../api';

async function bucarDadosCartaDeCredito(body) {
    try {
        const response = await apiGateway.post('/cartas-credito/dados', body);

        return response.data;
    } catch (error) {
        return [];
    }
}

export { bucarDadosCartaDeCredito };
